export const preprintSortFieldMap: Record<string, string> = {
  title: 'title',
  dateModified: 'date_modified',
};
